var _circle, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgConflictOrange = function SvgConflictOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 34,
    fill: "url(#conflict-orange_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m55.589 47.736-29.131-29.13a15.999 15.999 0 0 0-5.824-3.715l-8.261-3.018 3.018 8.261a15.999 15.999 0 0 0 3.715 5.824L45.148 52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m51.496 59.667-7.352 4.385a2 2 0 0 1-2.44-.304l-1.528-1.528 12.148-10.395L62.72 39.676l1.452 1.452a2 2 0 0 1 .233 2.55l-6.839 9.92 10.69 10.69a1 1 0 0 1 0 1.413l-2.054 2.054a1 1 0 0 1-1.414 0l-10.69-10.69M69.27 12.789c-9.352-2.274-18.741-.442-26.27 4.341M56 31c-4.714 0-8.97 1.918-12 5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "conflict-orange_svg__a",
    x1: 74.83,
    x2: 5.964,
    y1: 38.949,
    y2: 39.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5BE60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BE60",
    stopOpacity: 0.2
  })))));
};
export default SvgConflictOrange;